import {IBizProfitSharing, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {AProfitSharing} from "@/views/editor/service/profit_sharing/profit_sharing";
import {reactive, watch} from "vue";


export interface IProfitSharingMeta {
    distribution: {
        level_1_ratio: number[]
        level_2_ratio: number
        distributor_reg_require_sign: boolean
        subordinate_reg_required: 'view' | 'order' | 'pay'
        is_relationship_bind: boolean
        is_inviting_old_customers_without_commission: boolean
        bar_share_btn: {
            thumb: string
            title: string
            commission: number
        }
    }
    invitation_leaderboard: {
        title: string
        is_virtual_list: boolean
        list: number[]
        is_show_commission_sum: boolean
        is_employee_on_board: boolean
    }
    cash_back: {
        ratio: number
    }
    employee_awards: {
        steps: { [key: number]: number[] }
        support_indirect: boolean;
        is_inviting_old_customers_without_commission: boolean;
        is_reject_distributor: boolean;
    }
}

export default class ProfitSharing extends AProfitSharing implements IBizProfitSharing {
    readonly opt: IProfitSharingMeta
    readonly active = reactive({rate: {distribution: 0, employee: 0, cash_back: 0, all: 0}})

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = meta.setting as IProfitSharingMeta;
        watch(() => this.opt, () => {
            if (this.opt.distribution.level_1_ratio[1] < this.opt.distribution.level_1_ratio[0]) this.opt.distribution.level_1_ratio[1] = this.opt.distribution.level_1_ratio[0]
            this.active.rate.distribution = this.meta.subs.includes('distribution') ? this.opt.distribution.level_1_ratio[1] + this.opt.distribution.level_2_ratio : 0
            this.active.rate.employee = this.meta.subs.includes('employee') ? Object.values(this.opt.employee_awards.steps).reduce((a, b) => a = a < (b[0] > b[1] ? b[0] : b[1]) ? b[0] > b[1] ? b[0] : b[1] : a, 0) : 0
            this.active.rate.cash_back = this.meta.subs.includes('cash_back') ? this.opt.cash_back.ratio : 0
            this.active.rate.all = this.active.rate.distribution + this.active.rate.employee + this.active.rate.cash_back + 1
        }, {deep: true})
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        return {
            active: [
                {value: 'distribution', label: '分销员'},
                {value: 'employee', label: '内部成员奖'},
                {value: 'cash_back', label: '下单返现'}],
            preheating: [{value: 'distribution', label: '分销员'}],
            finished: []
        }[status]
    }

    resetMeta(status: EActivityStatus): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs(status).map(s => s.value as string))
        Object.assign(this.opt, {
            cash_back: {enable: true, ratio: 0},
            distribution: {
                distributor_reg_require_sign: false,
                enable: true,
                is_inviting_old_customers_without_commission: true,
                is_relationship_not_bind: false,
                level_1_ratio: [0, 0],
                level_2_ratio: 0,
                subordinate_reg_required: 'view',
                is_relationship_bind: true,
                bar_share_btn: {
                    thumb: 'https://static.pms.guandb.cn/media/system/icon_invite_pack.png',
                    title: '分享赚',
                    commission: 0
                }
            },
            employee_awards: {
                is_inviting_old_customers_without_commission: true,
                is_reject_distributor: true,
                steps: {0: [0, 0]},
                support_indirect: false
            },
            invitation_leaderboard: {
                is_employee_on_board: false,
                is_show_commission_sum: false,
                is_virtual_list: false,
                list: [],
                title: ""
            }
        })
        return this;
    }

    clearRate(): void {
        this.opt.distribution.level_1_ratio = [0, 0]
        this.opt.distribution.level_2_ratio = 0
        this.opt.employee_awards.steps = {0: [0, 0]}
        this.opt.cash_back.ratio = 0
        // let x = 0
        // x += this.meta.subs.includes('distribution') ? this.opt.distribution.level_1_ratio[1] + this.opt.distribution.level_2_ratio : 0
        // return x
    }

    shareRate(): number {
        return this.opt.distribution.level_1_ratio[1] + this.opt.distribution.level_2_ratio
    }
}